import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  email: {
    color: theme.palette.primary.main,
  },
}))

export default useStyles
